/**
 * Project: bicc-ffvt-website
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2021-08-04 15:28:24
 * License: MIT License
 */

import './css/map.less'


import { createApp } from 'vue'
import App from './map/App.vue'

createApp(App)
   .mount('#map-app')
